export default __webpack_public_path__ + "static/media/pengupaper.f9d66eec.png";